import React from 'react';

const PayoutBenefits = () => {
  return (
    <div className="card">
      <h3 className="card__header">Benefits of Payout Wallets</h3>
      <ul className="payout__intro__benefits">
        {PAYOUT_BENEFITS_LIST.map((benefit, index) => (
          <li key={`payout_benefit-${index}`} className="payout__intro__benefits__item">
            {benefit}
          </li>
        ))}
      </ul>
    </div>
  );
};

const PAYOUT_BENEFITS_LIST = [
  `Access and offer more payment with your choice of your
  selected cryptocurrency`,
  `Settle customers and issues rewards or cashouts to your
 customers swiftly`,
  `Make bulk payroll  payment by sending payment to multiple 
  address all at once`
];

export { PayoutBenefits };
